import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class ManagerGrid extends BaseComponent {
	
	static get properties() {
		return {	
			nodeId: {type: String}
		};
	}
	
	constructor() {
		super();
		
		var managerGrid = this;
		setTimeout(function(){
			managerGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var managerGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'vaadin-button',
					itemid: 'start',
					'class': 'spacer-toolbar-item',
					disabled: true,
					children:[
						ElementUtil.makeIcon('vaadin:play', ' Start')
					], 
					listeners: {
						click: function() {
							actionManagerStart(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'vaadin-button',
					itemid: 'stop',
					'class': 'spacer-toolbar-item',
					disabled: true,
					children:[
						ElementUtil.makeIcon('vaadin:stop', ' Stop')
					], 
					listeners: {
						click: function() {
							actionManagerStop(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'vaadin-button',
					itemid: 'restart',
					theme: 'contrast primary',
					'class': 'spacer-toolbar-item',
					disabled: true,
					children:[
						ElementUtil.makeIcon('vaadin:rotate-right', ' Restart')
					], 
					listeners: {
						click: function() {
							actionManagerRestart(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'vaadin-button',
					itemid: 'stats',
					'class': 'spacer-toolbar-item',
					disabled: true,
					children:[
						ElementUtil.makeIcon('vaadin:bar-chart', ' Show Current Stats')
					],
					listeners: {
						click: function() {
							actionShowManagerStats(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'dl-action-button',						
					theme: 'error primary',
					itemid: 'appRestart',					
					'class': 'spacer-toolbar-item',
					style: 'float: right;',
					permissions: ['ADMIN_SYSTEM:DELETE'],
					children:[
						ElementUtil.makeIcon('vaadin:rotate-right', ' App Restart')
					],
					listeners: {
						click: function() {
							actionAppRestart(grid.selectedItems[0]);
						}
					}
				}				
				
			]
		});		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [				
				{						
					path: 'name',
					header: 'Name',
					width: '5em'
				},
				{						
					path: 'order',
					header: 'Order',
					'text-align': 'center',
					width: '5em'
				},
				{
					path: 'managerClass',
					header: 'Manager Class',
					width: '9em',
					'flex-grow': '1'					
				},
				{						
					path: 'started',
					header: 'Started',
					width: '5em',
					'text-align': 'center',
					renderer: function(root, column, rowData) {
						if (rowData.item.started) {
							root.style = 'background-color: lightgreen; color: green; text-align: center;';
							root.innerHTML = '<vaadin-icon icon="vaadin:check"></vaadin-icon>';
						} else {
							root.style = 'background-color: lightgrey; color: red; text-align: center;';
							root.innerHTML = '<vaadin-icon icon="vaadin:close"></vaadin-icon>';
						}
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						
						if (item.started) {
							ElementUtil.query(toolbar, 'start').disabled = true; 
							ElementUtil.query(toolbar, 'stop').disabled = false;
						} else {
							ElementUtil.query(toolbar, 'start').disabled = false; 
							ElementUtil.query(toolbar, 'stop').disabled = true;
						}
						ElementUtil.query(toolbar, 'restart').disabled = false;
						ElementUtil.query(toolbar, 'stats').disabled = false;
					} else {
						ElementUtil.query(toolbar, 'start').disabled = true;						
						ElementUtil.query(toolbar, 'stop').disabled = true;
						ElementUtil.query(toolbar, 'restart').disabled = true;
						ElementUtil.query(toolbar, 'stats').disabled = true;
					}	
				}
			}
		});	
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		managerGrid.append(flexLayout);		
		
		
		var actionRefresh = function() {
			var loadMask = managerGrid.showLoading();	
			Service.getNodeService().getManagers(managerGrid.nodeId).then(function(managers){
				loadMask.remove();
				
				grid.activeItem = null;
				grid.items = managers;				
			});					
			
		};
		actionRefresh();
		
		var actionManagerStart = function(record) {
			var loadMask = managerGrid.showLoading('Starting ' + record.name + '...');
			Service.getNodeService().managerStart(managerGrid.nodeId, record.managerClass).then(function(result){
				loadMask.remove();
				if (result && result.success) {
					window.DL.MessageUtil.showToast('Success', record.name + ' Started', {									
						theme: 'success'
					});				
					
					actionRefresh();
				}
			});
		};

		var actionManagerStop = function(record) {
			var loadMask = managerGrid.showLoading('Stopping ' + record.name + '...');
			Service.getNodeService().managerStop(managerGrid.nodeId, record.managerClass).then(function(result){
				loadMask.remove();
				if (result && result.success) {
					window.DL.MessageUtil.showToast('Success', record.name + ' Stopped', {									
						theme: 'success'
					});				
					actionRefresh();
				}
			});
		};
	
		var actionManagerRestart = function(record) {
			var loadMask = managerGrid.showLoading('Restarting ' + record.name + '...');
			Service.getNodeService().managerRestart(managerGrid.nodeId, record.managerClass).then(function(result){
				loadMask.remove();
				if (result && result.success) {
					window.DL.MessageUtil.showToast('Success', record.name + ' Restarted', {									
						theme: 'success'
					});									
					actionRefresh();
				}
			});
		};
		
		var flattenManagerStats = function(stats, prefix) {
			var rows = [];
			if (stats === null || stats === undefined) {
				return rows;
			}
			if (Array.isArray(stats)) {
				stats.forEach(function(item, index) {
					rows = rows.concat(flattenManagerStats(item, prefix + '[' + index + ']'));
				});
				return rows;
			}
			if (typeof stats !== 'object') {
				rows.push({
					key: prefix || 'value',
					value: stats
				});
				return rows;
			}
			Object.keys(stats).forEach(function(key) {
				var fullKey = prefix ? prefix + '.' + key : key;
				var value = stats[key];
				if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
					rows.push({
						key: fullKey,
						value: '-',
						section: true
					});
					rows = rows.concat(flattenManagerStats(value, fullKey));
				} else {
					rows = rows.concat(flattenManagerStats(value, fullKey));
				}
			});
			return rows;
		};

		var actionShowManagerStats = function(record) {
			var detailWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record.name + ' — Current Stats',
				icon: 'vaadin:bar-chart',
				width: .75,
				height: .75,
				listeners: {
					ready: function() {
						detailWin.show();

						var detailTable = ElementUtil.create({
							tag: 'dl-detail-table',
							itemid: 'detailtable',
							slot: 'primary'
						});

						var loadmask = detailWin.showLoading();
						Service.getNodeService().getManagerStats(managerGrid.nodeId, record.managerClass).then(function(response) {
							loadmask.remove();
							var rows = [];
							if (!response || response.available === false) {
								rows.push({
									key: 'Message',
									value: response && response.message ? response.message : 'No stats available for this manager'
								});
							} else {
								rows = flattenManagerStats(response.stats, '');
								rows.sort(function(a, b) {
									return String(a.key).localeCompare(String(b.key));
								});
							}
							detailTable.updateDetails(rows);
						});

						var layout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								detailTable
							]
						});

						detailWin.addToContentElement(layout);
					}
				}
			});
		};

		var actionAppRestart = function() {
			
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Restart',
				message: 'Are you sure you want to restart the application? <br> <br> (The applicaiton will be unavailable while it restarts. <br> This restarts all managers...it does not restart the server.)',				
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = managerGrid.showLoading('Restarting... ');
							Service.getNodeService().deleteNode(managerGrid.nodeId).then(function(detailInfo){
								loadMask.remove();
								
								
								
							});							
						}
					},
					{
						text: 'No'
					}
				]
			});				
			
		};
		
	}
	
};
customElements.define('dl-manager-grid', ManagerGrid);


